// replace the user pool region, id, and app client id details
const config = {
  REGION: "eu-west-1",
  USER_POOL_ID: "eu-west-1_jlI1WwVkZ",
  USER_POOL_APP_CLIENT_ID: "42a60e0eqfvcbbkgs13i4r59cs",
  IDENTITY_POOL_ID: "eu-west-1:0e74c999-1122-43bb-bdc4-88dadd521b22",
};

export default config;
